module.exports = __webpack_public_path__ + "img/kart-logo-purple.9c790b41.svg";